import { projectSimpleService } from '@/services';
import { router } from '@/router';

const state = {
  items: [],
  statuses: {},
  detail: {
    provider: {},
    responsibleFaculty: {},
    solver: { key: '' },
    projectType: '',
    shareOfInvestmentCosts: null,
    budget: null,
    totalBudgetUniversity: null
  },
  projectLog: {
    items: [],
    totalCount: 0,
    search: {
      pageRows: 10,
      actualPage: 1,
      orderBy: '',
      orderByAsc: false
    }
  },
  totalCount: 0,
  simpleSearch: {
    filter: { startedOn: null, endedOn: null },
    pageRows: 10,
    actualPage: 1,
    orderBy: '',
    orderByAsc: false
  }
};

const actions = {
  getAll({ commit, dispatch }: any, searchQuery: any) {
    commit('saveSearchQuery', searchQuery);

    projectSimpleService
      .getAll(searchQuery)
      .then(
        projects => commit('getAllSuccess', projects),
        error => {
          dispatch('alert/error', JSON.stringify(error), {
            root: true
          });
        }
      )
      .finally();
  },
  getById({ commit, dispatch }: any, id: any) {
    projectSimpleService
      .getById(id)
      .then(
        project => {
          commit('getByIdSuccess', project);
        },
        error => {
          dispatch('alert/error', JSON.stringify(error), {
            root: true
          });
        }
      )
      .finally();
  },
  createProject({ dispatch }: any, { project }: any) {
    projectSimpleService
      .createProject(project)
      .then(
        () => {
          dispatch('alert/success', `notification.projectCreated`, {
            root: true
          });

          router.push('/programy');
        },
        error => {
          dispatch('alert/error', JSON.stringify(error), {
            root: true
          });
        }
      )
      .finally();
  },
  updateProject({ dispatch }: any, { id, project }: any) {
    projectSimpleService
      .updateProject(id, project)
      .then(
        () => {
          dispatch('alert/success', `notification.projectUpdated`, {
            root: true
          });
        },
        error => {
          dispatch('alert/error', JSON.stringify(error), {
            root: true
          });
        }
      )
      .finally();
  },
  deleteProject({ dispatch }: any, { id }: any) {
    projectSimpleService
      .deleteProject(id)
      .then(
        () => {
          dispatch('getAll', state.simpleSearch);
          dispatch('alert/success', `notification.projectDeleted`, {
            root: true
          });
        },
        error => {
          dispatch('alert/error', JSON.stringify(error), {
            root: true
          });
        }
      )
      .finally();
  },
  clearProject({ commit, dispatch }: any) {
    commit('clearProject');
  },
  getLog({ commit, dispatch }: any, { projectId, searchQuery }: any) {
    commit('saveLogSearchQuery', searchQuery);

    projectSimpleService
      .getLog(projectId, searchQuery)
      .then(
        logItems => commit('getLogAllSuccess', logItems),
        error => {
          dispatch('alert/error', JSON.stringify(error), {
            root: true
          });
        }
      )
      .finally();
  }
};

const mutations = {
  getAllSuccess(state: any, projects: any) {
    state.totalCount = projects.totalCount;
    state.items = projects;
  },
  getByIdSuccess(state: any, project: any) {
    if (!project.solver) {
      project.solver = { key: '' };
    }

    state.detail = project;
  },
  saveSearchQuery(state: any, searchQuery: any) {
    state.simpleSearch = searchQuery;
  },
  saveLogSearchQuery(state: any, searchQuery: any) {
    state.projectLog.simpleSearch = searchQuery;
  },
  clearProject(state: any) {
    state.detail = {
      provider: { key: '' },
      responsibleFaculty: {},
      solver: { key: '' },
      projectType: '',
      shareOfInvestmentCosts: null,
      budget: null,
      totalBudgetUniversity: null
    };
    state.projectLog = {
      items: [],
      totalCount: 0,
      simpleSearch: {
        pageRows: 10,
        actualPage: 1,
        orderBy: '',
        orderByAsc: false
      }
    };
  },
  getLogAllSuccess(state: any, logItems: any) {
    state.projectLog.totalCount = logItems.totalCount;
    state.projectLog.items = logItems;
  }
};

const getters = {
  getProjects: (state: any, getters: any) => () => {
    return state.items;
  },
  getTotalCount: (state: any, getters: any) => () => {
    return state.totalCount;
  },
  getLogItems: (state: any, getters: any) => () => {
    return state.projectLog.items;
  },
  getLogItemsCount: (state: any, getters: any) => () => {
    return state.projectLog.totalCount;
  },
  getProject: (state: any, getters: any) => () => {
    return state.detail;
  }
};

export const projectSimple = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
